import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';

export const encyclopediaActions = createActions({
  clearEncyclopediaNotifications: action((state) => {
    state.encyclopedia.speciesNotification = {};
  }),
});
